// extracted by mini-css-extract-plugin
export default {"container":"uW-z","title":"vW-z","link":"wW-z"};